import {ChangeDetectionStrategy, Component, input, TemplateRef, viewChild} from "@angular/core"
import {CdkMenu, CdkMenuItem} from "@angular/cdk/menu"

export type DownloadableDataObject = {
    downloadUrl: string
    mediaType?: string | null
    originalFileName?: string | null
    jpeg?: {downloadUrl: string} | null
    tiff?: {downloadUrl: string} | null
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-asset-download-menu",
    templateUrl: "./asset-download-menu.component.html",
    styleUrls: ["./asset-download-menu.component.scss"],
    imports: [CdkMenu, CdkMenuItem],
})
export class AssetDownloadMenuComponent {
    readonly $dataObject = input.required<DownloadableDataObject>({alias: "dataObject"})
    readonly menu = viewChild.required<TemplateRef<unknown>>("menu")
}
